import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { ServiceBase } from '../../interfaces/service-base.interface';
import { ReactiveEditComponent } from '../reactive-edit/reactive-edit.component';
import { FactoryBase } from '../../interfaces/factory-base.interface';

export abstract class ImplementedEditComponent<T> extends ReactiveEditComponent<T> implements OnInit {
  constructor(
    protected readonly service: ServiceBase<T>,
    protected readonly factory: FactoryBase<T>,
    protected readonly route: ActivatedRoute
  ) {
    super();

    this.options.refreshModelFromResponse = false;

    this.route.params.subscribe((param) => (this.id = +param['id']));
  }

  public loadModelFromForm() {
    this.model = this.factory.loadFromFormGroup(this.model, this.form);
  }

  public updateModel(): Observable<T> {
    return this.service.updateById(this.model, +this.id);
  }

  public getForm(): FormGroup {
    return this.factory.getFormGroup(this.model);
  }

  public getModel(): Observable<T> {
    return this.service.getById(+this.id);
  }

  public ngOnInit() {
    super.ngOnInit();
  }
}
